import { render, staticRenderFns } from "./InAppTutorials.vue?vue&type=template&id=a1711c60&"
import script from "./InAppTutorials.vue?vue&type=script&lang=js&"
export * from "./InAppTutorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2898369969/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1711c60')) {
      api.createRecord('a1711c60', component.options)
    } else {
      api.reload('a1711c60', component.options)
    }
    module.hot.accept("./InAppTutorials.vue?vue&type=template&id=a1711c60&", function () {
      api.rerender('a1711c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/InAppTutorials.vue"
export default component.exports